<app-dialog-close-button class="close-button" [compact]="true" (closed)="close()"></app-dialog-close-button>
<div vng-dialog-title class="text-center">Edit Plan</div>

<vng-dialog-content>
    <p class="tw-text-lg tw-text-center tw-mt-2 tw-mb-4">What would you like to do?</p>
</vng-dialog-content>

<vng-dialog-actions align="center" class="top-space mb-small" style="display:flex; justify-content:center; align-items:center; gap:15px">
    <button *ngIf="!isGrowthPlan()" vng-button variant="primary">
        Upgrade plan
    </button>
    <button vng-button [variant]="isGrowthPlan() ? 'primary' : 'outline'" (click)="pausePlan()">
        Pause plan
    </button>
    <button vng-button variant="outline" (click)="downgradePlan()">
       Downgrade plan
    </button>
</vng-dialog-actions>
